import { ISwapTracker } from '@nkr/models/index';
import { RowWrapper } from '../styles';

interface IProps {
    item: ISwapTracker,
    index: number
}

const SwapTrackerListRow = (props: IProps) => {
    const renderExtraText = (extra: string) => {
        if (extra != null && extra != '') {
            return <>{extra}</>;
        } else {
            return <>&nbsp;</>
        }
    };

    const renderSection = (status: number, extra: string) => {
        if (status == 0) {
            return <td style={{ backgroundColor: '#ddd', color: 'black', borderRight: '1px solid #eee' }}>{renderExtraText(extra)}</td>;
        }

        if (status == 1) {
            return <td style={{ backgroundColor: '#34823b', color: 'white', borderRight: '1px solid #eee' }}>{renderExtraText(extra)}</td>;
        }

        if (status == 2) {
            return <td style={{ backgroundColor: '#ecef23', color: 'black', borderRight: '1px solid #eee' }}>{renderExtraText(extra)}</td>;
        }

        if (status == 3) {
            return <td style={{ backgroundColor: '#bc0505', color: 'white', borderRight: '1px solid #eee' }}>{renderExtraText(extra)}</td>;
        }

        return <td></td>;
    };

    const { item, index } = props;

    let finalXmDate = '';

    if (item.finalXmComplete == 1) {
        finalXmDate = item.finalXmUploadDateTime;
    } else if (item.finalXmComplete == 2 || item.finalXmComplete == 3) {
        finalXmDate = item.finalXmDeadlineDateTime;
    }

    return (
        <RowWrapper useBackupPlan={false} padding='0px 1px 0px 1px !important'>
            <td>{index + 1}</td>
            <td>{item.swapManager ? item.swapManager.initials : ''}</td>
            <td>{item.chainId} / {item.clusterNumber} / {item.positionNumber}</td>
            <td>
                {item.donorCenter}
                {item.rdnCenterId > 0 ?
                    <span style={{ paddingLeft: 5 }}>(<span style={{ fontSize: 12, color: 'tomato', fontWeight: 600 }}>{item.rdnCenterAlias}</span>)</span>
                    : null}
            </td>
            <td>{item.donorAlias}</td>
            <td>{item.recipientCenter}</td>
            <td>{item.recipientAlias}</td>
            <td>{item.surgeryDate}</td>
            <td>{item.clusterStatus}</td>
            {renderSection(item.offerAcceptance, '')}
            {renderSection(item.challengingLogistics, '')}
            {renderSection(item.donorClearance, '')}
            {renderSection(item.serologiesReturned, item.shipBackDate)}
            {renderSection(item.serologiesRecorded, '')}
            {renderSection(item.finalXmComplete, finalXmDate)}
        </RowWrapper>
    );
}

export default SwapTrackerListRow;